import {
  Card,
  CardHeader,
  CardContent,
  Skeleton,
  Divider,
  Box,
} from "@mui/material";
import { DashGrid, CardCell } from "./style";

function CardSkel({ rows = 4 }) {
  return (
    <Card variant="outlined" sx={{ height: "100%", borderRadius: 2 }}>
      <CardHeader
        avatar={<Skeleton variant="rounded" width={40} height={40} />}
        title={<Skeleton width="45%" height={24} />}
      />
      <Divider />
      <CardContent>
        {Array.from({ length: rows }).map((_, i) => (
          <Box key={i} sx={{ py: 0.75 }}>
            <Skeleton width={`${85 - i * 8}%`} height={20} />
            <Skeleton width="35%" height={14} />
          </Box>
        ))}
      </CardContent>
    </Card>
  );
}

export default function DashboardSkeleton() {
  return (
    <DashGrid>
      {[0, 1, 2, 3, 4, 5].map((i) => (
        <CardCell key={i} style={{ "--i": i }}>
          <CardSkel />
        </CardCell>
      ))}
    </DashGrid>
  );
}
